export const EDIT_SUCCESS = 'Группа ЭЗС обновлена';
export const EDIT_ERROR = 'Не удалось обновить группу ЭЗС';
